import { ApiResult } from './../../models/ApiResult';
import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AdministrarService } from '../../services/administrar.service';
import { AuthService } from '../../services/auth.service';
import { LocalizationService } from '../../services/localization.service';
import { DOCUMENT } from '@angular/common';
import { AdminUsuario } from '../../models/AdminUsuario';
import { ModelHelpers } from '../../models/ModelHelpers';
import { Alert } from 'selenium-webdriver';
import { Console } from 'console';

@Component({
  selector: 'app-administracion-edit',
  templateUrl: './administracion-edit.component.html',
  styleUrls: ['./administracion-edit.component.css']
})
export class AdministracionEditComponent implements OnInit {

  administracionForm: FormGroup;
  title = 'Crear';
  id: string;
  guid: string;
  errorMessage: string = null;
  mensajeBueno: string = null;

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute,
    private _AdministrarService: AdministrarService, public _authService: AuthService,
    private _router: Router, public localization: LocalizationService, @Inject(DOCUMENT) private document: any) {
    if (this._avRoute.snapshot.params['id']) {
      this.guid = this._avRoute.snapshot.params['id'];
    }

    this.administracionForm = this._fb.group({
      id: [''],
      authID: [''],
      fullName: ['', [Validators.required]],
      displayName: [''],
      preferencias: ['', [Validators.required]],
      email: ['', [Validators.required]],
      phoneNumber: ['', [Validators.required]],
      userName: [''],
      codigoTecnico: [''],
      tecnico: false,
      validador: false,
      gestor: false,
      admin: false,
      visitador: false,
      isActive :false 
    });
  }

  ngOnInit() {
    this._authService.authIsLoaded.then(() => {
      if (this.guid != null) {
        this.title = 'Editar';
        this._AdministrarService.getUserByID(this.guid)
          .subscribe((resp: AdminUsuario) => {
            this.administracionForm.setValue(resp);
            this.guid = resp.authID;
            this.id = resp.id;
           
          }, err => this.errorMessage = err);
      }
    });
  }

  delete() {
    this.deleteAsync().then(y=> {
        if (y == true) {
        this._router.navigate(['/administracion']);
      }
      else {
        this.errorMessage = 'Error eliminando usuario';
      }
    });    
  }

  async deleteAsync() : Promise<boolean> {
    this.errorMessage = null;
    let idUsuario = Number.parseInt(this.id);
    let success = false;

    try {
       success = await (await this._AdministrarService.deleteUser(idUsuario).toPromise()).correct;
     
    }
    catch (exception) {
      
    }

    return success;
    
  }

  save() {
    this.errorMessage = null;
    let userModel = new AdminUsuario();
    ModelHelpers.copyFromForm(this.administracionForm.value, userModel);

    if (!this.administracionForm.valid) {
      console.log(this.administracionForm.errors);
      this.errorMessage = 'Error de validación';
      return;
    }

    if (this.title === 'Crear') {
      this._AdministrarService.createUser(userModel)
        .subscribe((data: any) => {
          if (data.correct === false) {
            this.errorMessage = data.mensaje;
            return;
          } else {
            this._router.navigate(['/administracion']);
          }
        }, err => { this.errorMessage = err; }
        );
    } else if (this.title === 'Editar') {

      this._AdministrarService.updateUser(userModel)
        .subscribe((data: ApiResult) => {
          if (data.correct === false) {
            this.errorMessage = data.mensaje;
            return;
          } else {
            this._router.navigate(['/administracion']);
          }
        }, err => { this.errorMessage = err; }
        );
    }
  }

  cancel(): void {
    this._router.navigate(['/administracion']);
  }

  restablecerContrasena() {
    this._AdministrarService.restablishPassword(this.guid).subscribe((x: any) => {
      if (x.estado === 'Correcto') {
        this.mensajeBueno = 'Email de restauración enviado correctamente.';
      } else if (x.estado === 'Error') {
        this.errorMessage = 'No se ha podido enviar el email de restauración, por favor, contacte con un administrador.';
      }
    });
  }

  get fullName() { return this.administracionForm.get('fullName'); }
  get email() { return this.administracionForm.get('email'); }
  get phoneNumber() { return this.administracionForm.get('phoneNumber'); }
  get preferencias() { return this.administracionForm.get('preferencias'); }
}
